.controls {
  bottom: auto !important;
  top: o !important;
}

.control {
  background-color: var(--mantine-color-secondary-light) !important;
  color: white !important;
  box-shadow: none;
  border-radius: 100% !important;
  opacity: 1 !important;
}

.control[data-inactive] {
  opacity: 0 !important;
}